<template>
  <div class="scrollable">
  	<div  style="margin-bottom:70px;" class="img" :key="index" v-for="(item,index) in imgList">
     <img :src="item"> 
    </div>
  </div>
</template>

<script>  
export default {
	name: 'reportsImg',
	data () {
	    return {
        imgList:[]
	    }
  	},
  	created() {
  		let _this = this;
      let str = sessionStorage.getItem("reportImgs");
      _this.imgList = str.split(",");
    },
  	methods:{

    }
}
</script>

<style scoped>
  .img{
    width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/phyExServices/medicalReports/reportImg.vue